<div class="container mt-3">
  <p-confirmpopup></p-confirmpopup>
  <form [formGroup]="noteForm" (ngSubmit)="saveNote()">
    <h5>Neue Bemerkung</h5>
    <div class="p-fluid grid mt-3">

      <div class="field col-12">
        <p-floatlabel>
          <p-select class="w-100" [options]="commentService.contactTypes" formControlName="contact_type"
                      optionLabel="title" inputId="contact_type" [showClear]="true"></p-select>
          <label [for]="'contact_type'">Kontaktart</label>
        </p-floatlabel>
      </div>

      <div class="field col-12">
        <p-floatlabel variant="in">
          <textarea pTextarea class="w-100" id="text" formControlName="text"></textarea>
          <label for="text">Bemerkung</label>
        </p-floatlabel>
      </div>
    </div>
    <div class="w-100 d-flex justify-content-end mb-3">
      <p-button type="submit" icon="pi pi-save" [rounded]="true" label="BEMERKUNG SPEICHERN"></p-button>
    </div>
  </form>


  <p-table [value]="socialSupportService.socialSupportNotes" [paginator]="socialSupportService.socialSupportNotes.length > 10" [rows]="10"
           [showCurrentPageReport]="true" currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords} Bemerkungen"
           [loading]="loading">
    <ng-template pTemplate="header">
      <tr>
        <th>Datum</th>
        <th>Kontaktart</th>
        <th>Bemerkung</th>
        <th>Autor</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-note>
      <tr>
        <td>{{note.createdAt | date : "dd.MM.yyyy"}}</td>
        <td>{{note.contact_type?.title}}</td>
        <td>{{note.text}}</td>
        <td>{{note.users_permissions_user?.username}}</td>
        <td>
          <p-button icon="pi pi-times" (click)="deleteNote(note.id, $event)"
                  [rounded]="true" severity="danger" [outlined]="true"></p-button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">Keine Bemerkungen</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div class='container mt-8'>
  <h3>Dateien</h3>
  <form [formGroup]="attachmentForm" (ngSubmit)="saveFile()">
    <h5>Datei Hochladen</h5>
    <div class="p-fluid grid mt-3">

      <div class="field col-12">
        <p-floatlabel>
          <input pInputText id="name" formControlName="name" class='w-100' />
          <label for="name">Name der Datei</label>
        </p-floatlabel>

        @if (attachmentForm.get('name')?.errors?.['required'] && attachmentForm.get('name')?.dirty) {
          <span class='p-error'>
            Name ist erforderlich
          </span>
        }
      </div>
    </div>

    <p-fileupload #fileUpload
                  mode="basic"
                  chooseLabel="Datei Auswählen"
                  name="file"
                  [accept]="acceptedFileTypes"
                  maxFileSize="5000000"
                  invalidFileTypeMessageSummary="{0}: Ungültiger Dateityp"
                  invalidFileTypeMessageDetail="Nur PDF-Dateien sind erlaubt."
                  invalidFileSizeMessageSummary="{0}: Ungültige Dateigröße"
                  invalidFileSizeMessageDetail="Maximale Dateigröße: {0}. Bitte Datei komprimieren"
                  (onSelect)="onFileSelect($event)"
                  (click)="fileUpload.clear()"></p-fileupload>

    <div class="w-100 d-flex justify-content-end mb-3">
      <p-button type="submit" icon="pi pi-save" [rounded]="true" label="DATEI HOCHLADEN"></p-button>
    </div>
  </form>

  @if (socialSupportService.socialSupportAttachments.length > 0) {
    <p-table [value]="socialSupportService.socialSupportAttachments" [paginator]="socialSupportService.socialSupportAttachments.length > 10" [rows]="10"
             [showCurrentPageReport]="true" currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords} Dateien"
             [loading]="loading">

      <ng-template pTemplate="header">
        <tr>
          <th>Beschreibung</th>
          <th>Dateiname</th>
          <th>Erstellt am</th>
          <th></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-attachment>
        <tr>
          <td>{{ attachment.name }}</td>
          <td>{{ attachment.file?.name }}</td>
          <td>{{ attachment.createdAt | date : 'dd.MM.yyyy \'um\' HH:mm \'Uhr\'' }}</td>
          <td>
            <p-button icon="pi pi-download" severity="success" [outlined]="true" [rounded]="true"
                      (click)="download(attachment)"></p-button>
            @if (canDeleteFiles) {
              <p-button icon="pi pi-trash" class="ml-2" severity="danger" [rounded]="true" [outlined]="true"
                        (click)="deleteAttachment(attachment.id, $event)"></p-button>
            }
          </td>
        </tr>
      </ng-template>

    </p-table>
  }
</div>
